import React from "react";
import ExtensionRouter from './extension/Router';
export { getFields, getReplyFields } from './extension/Router';

export default function ExtensionPmRouter(props){
    return <ExtensionRouter {...props} mode='PM' />;
}